import { type ReactNode, useEffect, useState } from "react";

interface Props {
  children: ReactNode;
}

/**
 * This component is used to render a component only on the client side.
 * It is used to avoid hydration errors and prevent something from being rendered on the server.
 */
const ClientOnly = ({ children }: Props) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return <>{children}</>;
};

export { ClientOnly };
